<!-- <section> -->
<div id="a1" style="background: white;">
    <nav class="navbar navbar-expand-xl navbar-light bg-white" id="mt_top">

        <a class="navbar-brand egd-navbar-brand d-none d-md-block" href="javascript:void(0)"
            (click)="openLink('HOMPAGE_BASE_URL','','_self');">
            <img [src]="this.provider_img" class="egd-navbar-logo" alt="eGlobalDoctors - Care for better life"
                id="navLogo">
        </a>



        <button class="openbtn d-none d-md-block d-xl-none" (click)="toggleNav()" *ngIf="this.is_primary_provider">
            <a href="javascript:void(0)">
                <img src="./assets/images/menu_icon.svg" alt="">
            </a>
        </button>


        <div class="row d-md-none justify-content-md-between" *ngIf="this.is_primary_provider">
            <div class="col-3">
                <button class="openbtn d-block d-xl-none" (click)="toggleNav()">
                    <a href="javascript:void(0)">
                        <img src="./assets/images/menu_icon.png" alt="">
                    </a>
                </button>
            </div>
            <div class="col-9">
                <a class="navbar-brand egd-navbar-brand" href="javascript:void(0)"
                    (click)="openLink('HOMPAGE_BASE_URL','','_self');">
                    <img [src]="this.provider_img" class="egd-navbar-logo" alt="eGlobalDoctors - Care for better life">
                </a>
            </div>
        </div>

        <div class="collapse navbar-collapse" id="navbarSupportedContent" *ngIf="this.is_primary_provider">
            <ul class="navbar-nav">
                <!-- <li class="nav-item active egd-item">
                    <a class="nav-link egd-link" href="./index.html">Home <span class="sr-only">(current)</span></a>
                </li> -->
                <li class="nav-item egd-item my-auto">
                    <a class="nav-link egd-link" href="javascript:void(0)"
                        (click)="openLink('HOMPAGE_BASE_URL','howitworks','_self');">How It Works</a>
                </li>
                <!-- <li class="nav-item egd-item my-auto">
                       
    
                        <a class="nav-link egd-link dropdown-toggle" href="javascript:void(0)" id="services" role="button"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Services
                        </a>
                        <div class="dropdown-menu our-services-dropdown" aria-labelledby="services">
                            <a class="dropdown-item egd-link" href="javascript:void(0)"
                                (click)="openLink('HOMPAGE_BASE_URL','#our-service','_self');">Our
                                Services</a>
    
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item egd-link" href="javascript:void(0)"
                                (click)="openLink('HOMPAGE_BASE_URL','diet-programs','_self')">Diet Programs</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item egd-link" href="javascript:void(0)"
                                (click)="openLink('HOMPAGE_BASE_URL','primary-consultation-telehealth-consultation','_self')">Primary
                                Consultation</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item egd-link" href="javascript:void(0)"
                                (click)="openLink('HOMPAGE_BASE_URL','expert-second-medical-opinion','_self')">Expert
                                Second Medical Opinion</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item egd-link" href="javascript:void(0)"
                                (click)="openLink('HOMPAGE_BASE_URL','multispecialty-telehealth-consultation','_self')">Multi-Specialty
                                Consultation</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item egd-link" href="javascript:void(0)"
                                (click)="openLink('HOMPAGE_BASE_URL','eglobal-pharmacy','_self')">eGlobal Pharmacy</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item egd-link" href="javascript:void(0)"
                                (click)="openLink('HOMPAGE_BASE_URL','eglobal-diagnostics','_self')">eGlobal
                                Diagnostics</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item egd-link" href="javascript:void(0)"
                                (click)="openLink('HOMPAGE_BASE_URL','eglobal-homecare','_self')">eGlobal Homecare</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item egd-link" href="javascript:void(0)"
                                (click)="openLink('HOMPAGE_BASE_URL','fmc','_self')">Free Medical Counseling</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item egd-link" [routerLink]="['/', this.slug, 'covid-19']"                            >COVID-19</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item egd-link" href="javascript:void(0)"
                                (click)="openLink('HOMPAGE_BASE_URL','equipmentsupport','_self')">Equipment Support</a>
                            <div class="dropdown-divider"></div>
                        </div>
                    </li> -->

                <li class="nav-item egd-item my-auto">
                    <a class="nav-link egd-link" href="javascript:void(0)"
                        (click)="openLink('HOMPAGE_BASE_URL','online-doctor-consultation-pricing','_self');">Pricing</a>
                </li>
                <li class="nav-item egd-item my-auto">
                    <a class="nav-link egd-link dropdown-toggle" href="javascript:void(0)" id="faq" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        FAQ
                    </a>
                    <div class="dropdown-menu our-services-dropdown" aria-labelledby="faq">
                        <a class="dropdown-item egd-link" href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','faq-patient','_self');">For Patients</a>

                        <div class="dropdown-divider" *ngIf="!this.is_uk_country"></div>
                        <a class="dropdown-item egd-link" href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','faq-cg-patient','_self');"
                            *ngIf="!this.is_uk_country">For CoverGenius Patient</a>

                        <div class="dropdown-divider" *ngIf="!this.is_uk_country"></div>
                        <a class="dropdown-item egd-link" href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','faq-h-and-c-patient','_self');"
                            *ngIf="!this.is_uk_country">For Help and Care
                            Patient</a>

                        <div class="dropdown-divider"></div>

                        <a class="dropdown-item egd-link" href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','faq-doctor','_self');">For Doctors</a>

                        <div class="dropdown-divider" *ngIf="!this.is_uk_country"></div>
                        <a class="dropdown-item egd-link" href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','faq-other_healthcare_providers','_self');"
                            *ngIf="!this.is_uk_country">For
                            OHP</a>
                    </div>

                </li>
                <!-- <li class="nav-item egd-item my-auto">
                        <a class="nav-link egd-link" href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','business-page','_self');">Partner With Us</a>
                    </li> -->
                <li class="nav-item egd-item my-auto">
                    <a class="nav-link egd-link" href="javascript:void(0)"
                        (click)="openLink('HOMPAGE_BASE_URL','aboutus','_self');">About Us</a>
                </li>
                <!-- <li class="nav-item egd-item my-auto">
                        <a class="nav-link egd-link" href="javascript:void(0)"
                            (click)="openLink('BLOGS_BASE_URL','','_self');">Blogs</a>
                    </li> -->
                <li class="nav-item egd-item my-auto" (click)="toggleNav()">
                    <a href="javascript:void(0)" class="nav-link egd-link">
                        More
                        <img src="../assets/images/menu_icon.svg" alt="">
                    </a>
                </li>


            </ul>
            <!-- <form class="form-inline my-2 my-lg-0">
                    <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
                    <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
                </form> -->

            <div class="egd-login-register-button mx-1">
                <button type="button" (click)="openLink('HOMPAGE_BASE_URL','','_self');"
                    class="btn btn-default btn-primary white-theme-egd-bg-btn my-auto mx-3 egd-login-register-buttons egd-login-back-button"
                    role="button">
                    <a href="javascript:void(0)" aria-pressed="true">
                        <span class="white-theme-egd-bg-btn-label ">
                            &#8592; Back to Home page
                        </span>
                    </a>
                </button>
            </div>
        </div>




        <div id="mySidepanel" class="sidepanel" *ngIf="this.is_primary_provider">
            <a href="javascript:void(0)" class="closebtn" (click)="closeNav()">
                <div>×</div>
            </a>
            <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL','','_self');" class="mt-3">Home</a>
            <!-- <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL','#our-service','_self');">Services</a> -->
            <div class="dropdown-mb-divider"></div>
            <a href="#ConsultDoctor" data-toggle="collapse" class="dropdown-toggle">Consult Doctor</a>
            <div id="ConsultDoctor" class="collapse">
                <ul style="list-style-type: none;padding: 0;">
                    <li style="padding: 0;"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','primary-consultation-telehealth-consultation','_self')"
                            class="ml-4 sidebar-color">Primary
                            Consultation</a></li>
                    <div class="dropdown-mb-divider"></div>
                    <li style="padding: 0;"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','expert-second-medical-opinion','_self')"
                            class="ml-4 sidebar-color">Expert Second
                            Medical
                            Opinion</a></li>
                    <div class="dropdown-mb-divider"></div>
                    <li style="padding: 0;"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','multispecialty-telehealth-consultation','_self')"
                            class="ml-4 sidebar-color">Multi-Specialty
                            Consultation</a></li>
                    <div class="dropdown-mb-divider"></div>
                    <li style="padding: 0;" *ngIf="!this.is_uk_country"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','diet-programs','_self')"
                            class="ml-4 sidebar-color">Diet
                            Programs</a></li>
                </ul>
            </div>
            <div class="dropdown-mb-divider"></div>
            <a href="javascript:void(0)"
                (click)="openLink('HOMPAGE_BASE_URL','online-doctor-consultation-pricing','_self');">Pricing</a>
            <div class="dropdown-mb-divider"></div>
            <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL','howitworks','_self');">How It Works</a>
            <div class="dropdown-mb-divider" *ngIf="!this.is_uk_country"></div>
            <a href="javascript:void(0)"
                (click)="openLink('HOMPAGE_BASE_URL','affordable-healthcare-packages','_self');"
                *ngIf="!this.is_uk_country">Health Packages</a>
            <div class="dropdown-mb-divider"></div>
            <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL','cancer-care','_self');">Cancer
                Care</a>
            <div class="dropdown-mb-divider"></div>
            <a href="#egdServices" data-toggle="collapse" class="dropdown-toggle">eGlobal Services</a>
            <div id="egdServices" class="collapse">
                <ul style="list-style-type: none;padding: 0;">
                    <li style="padding: 0;"><a (click)="openLink('HOMPAGE_BASE_URL','#our-service','_self');"
                            class="ml-4 sidebar-color">Our
                            Services</a></li>
                    <div class="dropdown-mb-divider"></div>
                    <li style="padding: 0;"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','#featured-doctors','_self');"
                            class="ml-4 sidebar-color">Doctors</a>
                    </li>
                    <div class="dropdown-mb-divider" *ngIf="!this.is_uk_country"></div>
                    <li style="padding: 0;" *ngIf="!this.is_uk_country"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','eglobal-pharmacy','_self')"
                            class="ml-4 sidebar-color">eGlobal
                            Pharmacy</a></li>
                    <div class="dropdown-mb-divider" *ngIf="!this.is_uk_country"></div>
                    <li style="padding: 0;" *ngIf="!this.is_uk_country"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','eglobal-diagnostics','_self')"
                            class="ml-4 sidebar-color">eGlobal
                            Diagnostics</a></li>
                    <div class="dropdown-mb-divider" *ngIf="!this.is_uk_country"></div>
                    <li style="padding: 0;" *ngIf="!this.is_uk_country"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','eglobal-homecare','_self')"
                            class="ml-4 sidebar-color">eGlobal
                            HomeCare</a></li>
                </ul>
            </div>
            <div class="dropdown-mb-divider" *ngIf="!this.is_uk_country"></div>
            <a href="#otherServices" data-toggle="collapse" class="dropdown-toggle" *ngIf="!this.is_uk_country">Other
                Services</a>
            <div id="otherServices" class="collapse" *ngIf="!this.is_uk_country">
                <ul style="list-style-type: none;padding: 0;">
                    <li style="padding: 0;"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','fmc','_self')" class="ml-4 sidebar-color">Free Medical
                            Counseling</a></li>
                    <div class="dropdown-mb-divider"></div>
                    <li style="padding: 0;"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','equipmentsupport','_self')"
                            class="ml-4 sidebar-color">Equipment
                            Support</a></li>
                    <div class="dropdown-mb-divider"></div>
                    <li style="padding: 0;"><a href="javascript:void(0)"
                            onclick="openWebsiteLinks('PORTAL_BASE_URL','covid-19','_blank')"
                            class="ml-4 sidebar-color">COVID-19</a></li>
                    <div class="dropdown-mb-divider"></div>
                    <li style="padding: 0;"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','medical_students','_self')"
                            class="ml-4 sidebar-color">Medical
                            Students</a></li>
                    <div class="dropdown-mb-divider"></div>
                    <li style="padding: 0;"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','cme_programs','_self')" class="ml-4 sidebar-color">CME
                            Programs</a></li>
                </ul>
            </div>
            <div class="dropdown-mb-divider"></div>
            <a href="#FAQ" data-toggle="collapse" class="dropdown-toggle">FAQ</a>
            <div id="FAQ" class="collapse">
                <ul style="list-style-type: none;padding: 0;">
                    <li style="padding: 0;"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','faq-patient','_self');" class="ml-4 sidebar-color">For
                            Patient</a>
                    </li>
                    <div class="dropdown-mb-divider"></div>
                    <li style="padding: 0;"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','faq-doctor','_self');" class="ml-4 sidebar-color">For
                            Doctor</a>
                    </li>
                    <div class="dropdown-mb-divider" *ngIf="!this.is_uk_country"></div>
                    <li style="padding: 0;" *ngIf="!this.is_uk_country"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','faq-cg-patient','_self');"
                            class="ml-4 sidebar-color">For
                            CoverGenius
                            Patient</a></li>
                    <div class="dropdown-mb-divider" *ngIf="!this.is_uk_country"></div>
                    <li style="padding: 0;" *ngIf="!this.is_uk_country"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','faq-other_healthcare_providers','_self');"
                            class="ml-4 sidebar-color">For OHP</a></li>
                </ul>
            </div>
            <div class="dropdown-mb-divider"></div>
            <a href="#aboutus" data-toggle="collapse" class="dropdown-toggle">About us</a>
            <div id="aboutus" class="collapse">
                <ul style="list-style-type: none;padding: 0;">
                    <li style="padding: 0;"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','aboutus','_self');" class="ml-4 sidebar-color">About
                            Us</a>
                    </li>
                    <div class="dropdown-mb-divider" *ngIf="!this.is_uk_country"></div>
                    <li style="padding: 0;"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','news','_self');" class="ml-4 sidebar-color" *ngIf="!this.is_uk_country">News</a>
                    </li>
                    <div class="dropdown-mb-divider" *ngIf="!this.is_uk_country"></div>
                    <li style="padding: 0;"><a href="javascript:void(0)"
                            (click)="openLink('BLOGS_BASE_URL','','_self');" class="ml-4 sidebar-color" *ngIf="!this.is_uk_country">Blogs</a></li>
                    <div class="dropdown-mb-divider" *ngIf="!this.is_uk_country"></div>
                    <li style="padding: 0;" *ngIf="!this.is_uk_country"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','#our-partners','_self');"
                            class="ml-4 sidebar-color">Our Partners</a></li>
                    <div class="dropdown-mb-divider" *ngIf="!this.is_uk_country"></div>
                    <li style="padding: 0;"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','leadership','_self');"
                            class="ml-4 sidebar-color" *ngIf="!this.is_uk_country">Leadership</a>
                    </li>
                    <div class="dropdown-mb-divider"></div>
                    <li style="padding: 0;"><a href="javascript:void(0)"
                            (click)="openLink('HOMPAGE_BASE_URL','healthvideos','_self');"
                            class="ml-4 sidebar-color">Patient
                            Videos</a></li>
                </ul>
            </div>
            <div class="dropdown-mb-divider" *ngIf="!this.is_uk_country"></div>
            <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL','offers','_self');"
                *ngIf="!this.is_uk_country">Offers</a>
            <div class="dropdown-mb-divider"></div>
            <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL','business-page','_self');">Partner With
                Us</a>
            <div class="dropdown-mb-divider"></div>
            <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL','contactus','_self');">Contact Us</a>
        </div>




    </nav>
</div>
<!-- </section> -->